import * as React from 'react';
import ReusableDiv from 'src/support/ReusableDiv';
import CheckoutTotal from './CheckoutItemInfo/CheckoutTotal';
import ContinueShopping from './CheckoutItemInfo/ContinueShopping';
import Notification from 'src/component/Global/Checkout/Notification';
import { useOrderStore } from 'src/hooks/order';
import System from 'src/helper/system';
import { useState, useEffect } from 'react';
import { __remove, __set } from 'src/store/axios_indicator';
import { useAxiosIndicatorCheck } from 'src/store/hook/useAxiosIndicatorCheck';
import Constants from 'src/support/Constants';
import CheckoutOrderItemList from './CheckoutSteps/CheckoutOrderItemList';
import { useQuoteDetailStore } from 'src/hooks/quote-detail';
import QuoteInformationCheckout from './CheckoutSteps/QuoteInformationCheckout';
import Order from "@system/config/order";
import AuthConfig from "@system/config/auth";
import DOMAttachToSystem from 'src/captain/DOMAttachToSystem';
import Helper from 'src/support/Helper';

const SuccessCheckout = () => {
    const [__check] = useAxiosIndicatorCheck();
    const [{ }, { fetch_place_order_items }, { }] = useOrderStore();
    const [{ }, { }, { destroy_cart_quote_active_session }] = useQuoteDetailStore();
    const [checkoutData, setCheckoutData] = useState([])
    const [paymentMethod, setPaymentMethod] = useState([])
    const [isQuote, setIsQuote] = useState(false); // 14990
    const [firstServerCall, setFirstServerCall] = useState(true);
    const [monitorFunctionCall, setMonitorFunctionCall] = useState(false);
    let carrierAcctNumber = sessionStorage.getItem("carrierAccountNumber");

    useEffect(() => {
        const c = System.getParams();
        async function fetchHere() {
            const detail = await fetch_place_order_items(c.orderId);
            if (detail && Object.entries(detail.payload).length > 0) {
                setCheckoutData(detail.payload);
                if (detail.payload.sapQuoteNumber) {
                    setIsQuote(true)
                    destroy_cart_quote_active_session()
                }
            }
            setPaymentMethod(await AuthConfig.getAccountDescription())
            setTimeout(() => {
                __remove('CART_API_CALL', 'VIEW_CART_API_CALL')
            }, 500);
            setFirstServerCall(false)
        }

        if (sessionStorage.getItem(c.orderId)) {
            __set('CART_API_CALL', 'VIEW_CART_API_CALL'); // set same loader as like checkout total
            fetchHere()
            sessionStorage.setItem("successUrl", "order-confirm")
        } else {
            window.location.href = Order.getOrderHistoryRouteURL()
        }
        setTimeout(() => {
            sessionStorage.removeItem(c.orderId)
        }, 500);

    }, []);

    console.log(checkoutData);
    const renderAddress = (addressType) => {
        const _address = checkoutData.orderAddress.find(f => f.addressType === addressType);
        if (_address) {
            return (
                <div>
                    <div className="font-16 font-bold font-apecru">{_address.name}</div>
                    <p>{_address.lineOne} <br />{_address.cityName}, {_address.postalCode} <br />{_address.countryCode} </p>
                </div>
            )
        } else { return <></> }
    };

    const renderInvoiceAddress = () => {
        let _address = sessionStorage.getItem("invoiceAddress");

        if (_address) {
            _address = JSON.parse(_address)
            return (
                <div>
                    <div className="font-16 font-bold font-apecru">{_address.name}</div>
                    <p>{_address.address_line} <br />{_address.city_name}, {_address.postal_code} <br />{_address.country_code} </p>
                </div>
            )
        } else { return <></> }
    };

    /**
     * Author : Pankaj
     * Date   : 08-08-2023
     * Reason : Hide DX Loader once our component loads.
     */
    React.useEffect(() => {
        if (checkoutData && Object.entries(checkoutData).length > 0 && document.getElementsByClassName('snippet') && document.getElementsByClassName('snippet').length > 0) {
            document.getElementsByClassName('snippet')[0].style.display = 'none';
        }
        if (firstServerCall === false && !monitorFunctionCall) {
            Helper.monitorJSDx()
            setMonitorFunctionCall(true)
        }
    }, [checkoutData])

    return (
        <>
            {(checkoutData && Object.entries(checkoutData).length > 0) &&
                <>
                    {process.env.NODE_ENV !== "development" && <DOMAttachToSystem />}
                    <div className='checkout-process pt-3'>
                        <div className='container'>
                            <Notification orderDetail={checkoutData} />
                            <div className="bs5 row">
                                <div className="col-12"></div>
                                <div className="col-12 col-sm-12 col-md-8 col-lg-9 col-xl-9">
                                    <div className="checkout-steps">
                                        {checkoutData.sapQuoteNumber && <QuoteInformationCheckout quoteNumber={checkoutData.sapQuoteNumber} />}
                                        <div className="shipping-address steps-inner mb-3 active completed">
                                            {ReusableDiv.checkoutStepTitle("1. Shipping and VAT")}
                                            {/* <div className="shipping-address-detail checkbox-steps-content">
                                                <div className="bs5 row">
                                                    <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                                        {renderAddress(Constants.addressType.SHIP_TO)}
                                                    </div>
                                                    <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                                        <div className="step-complete-show">
                                                            <div className="info-text">
                                                                <p className="mb-2">ATTN: {checkoutData.attn}</p>
                                                                <p className="mb-2">Phone Number: {checkoutData.telephoneNumber}</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div> */}
                                              <div className="shipping-address-detail checkbox-steps-content">
                                                <div className="bs5 row">
                                                    <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                                        {renderAddress(Constants.addressType.SHIP_TO)}
                                                    </div>
                                                    <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                                        <div className="step-complete-show">
                                                            <div className="info-text">
                                                                <p className="mb-2">ATTN: {checkoutData.attn}</p>
                                                                <p className="mb-2">Phone Number: {checkoutData.telephoneNumber}</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="shipping-method steps-inner mb-3 active completed">
                                            {ReusableDiv.checkoutStepTitle("2. Shipping Method")}
                                            <div className="checkbox-steps-content">
                                                <div className="step-complete-show">
                                                    <div className="bs5 row">
                                                        <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                                            <h3 className='mt-0'>SHIPPING METHOD OPTIONS:</h3>

                                                            <div className="mt-3">
                                                            {Helper.valueIsNotNull(carrierAcctNumber) ?
                                                                (
                                                                    <div className="inv-add border-0 ps-0">
                                                                        <b>Carrier Account Number</b>
                                                                        <p>{carrierAcctNumber}</p>
                                                                    </div>
                                                                ) : (
                                                                    <div className="inv-add border-0 ps-0">
                                                                        <b>Avnet's Carrier Options </b>
                                                                        <p>{ReusableDiv.AvnetCarrierOptionHeader()}</p>
                                                                    </div>
                                                                )
                                                            }
                                                        </div>
                                                        </div>
                                                        
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="shipping-method steps-inner mb-3 active completed">
                                            {ReusableDiv.checkoutStepTitle("3. Payment Method")}
                                            <div className="checkbox-steps-content">
                                                <div className="step-complete-show">
                                                    <div className="bs5 row">
                                                        <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                                            <h3 className='mt-0'>PAYMENT METHOD:</h3>
                                                            <p>{'Avnet Credit Line / ' + paymentMethod}</p>
                                                        </div>
                                                        <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                                            <div className="inv-add border-0 ps-0">
                                                                <h3 className='mt-0'>INVOICE ADDRESS:</h3>
                                                                {renderInvoiceAddress()}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <CheckoutOrderItemList itemList={checkoutData.items} isQuote={isQuote} />
                                    </div>
                                </div>
                                <div className="col-12 col-sm-12 col-md-4 col-lg-3 col-xl-3">
                                    <CheckoutTotal />
                                    <ContinueShopping />
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            }

        </>
    );
}

export default SuccessCheckout;